import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from 'src/app/injection-constants';
import { BackgroundTask } from '../models/background-task';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BackgroundTaskService {

  constructor(private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string) { }

  getTasks(): Observable<BackgroundTask[]> {
    return this.http.get<BackgroundTask[]>(`${this.apiBaseUrl}/management/backgroundTasks`);
  }

  cancelTask(taskId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiBaseUrl}/management/backgroundTasks/${taskId}`);
  }
}
